import type { ReactNode } from 'react'

type EmptyStateProps = {
  title: string
  body: string
  cta?: ReactNode
  mark?: string
}

export function EmptyState({ title, body, cta, mark }: EmptyStateProps) {
  return (
    <div className="empty">
      {mark && <div className="empty-mark">{mark}</div>}
      <div className="empty-title">{title}</div>
      <div className="empty-body">{body}</div>
      {cta && <div className="empty-cta">{cta}</div>}
    </div>
  )
}
